import React, { useEffect, useState } from "react";
import Radio from "../../Components/Radio";
import Select from "../../Components/Select";
import Input from "../../Components/Input";

const Finance = (props) => {
  const {
    userQuery,
    setUserQuery,
    activeButton,
    setActiveButton,
    errors,
    activeButton1,
    setActiveButton1,
  } = props;

  // functionality handling base loan amount percantage

  userQuery.Base_loan_amount = (userQuery.Property_Value * userQuery.ltv) / 100;

  // functionality handling other financing percantage

  if (userQuery.ltv > userQuery.cltv) {
    userQuery.other_financing =
      (userQuery.Property_Value * userQuery.cltv) / 100;
  } else {
    let changecltv = userQuery.cltv - userQuery.ltv;
    userQuery.other_financing = (userQuery.Property_Value * changecltv) / 100;
  }

  // console.log("user query", userQuery);

  // Data for Radio buttons used in Occupancy

  const data = [
    { value: "Primary Residence", label: "Primary Residence" },
    { value: "Second Home", label: "Second Home" },
    { value: "Property", label: "Investment Property" },
  ];
  useEffect(() => {
    // console.log("data:", data);
  }, data);
  // Data for Radio buttons used in Loan Purpose

  const optionLoan = [
    { value: "Purchase", label: "Purchase" },
    { value: "No Cash-Out Refi", label: "No Cash-Out Refi" },
    { value: "Cash-Out Refi", label: "Cash-Out Refi" },
  ];

  // Data for Radio buttons used in Mortgage Type

  const optionMort = [
    { value: "QM", label: "QM" },
    { value: "NON-QM", label: "NON-QM" },
    { value: "Jumbo", label: "Jumbo" },
  ];
  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
  };
  const handleButtonClick1 = (buttonName) => {
    setActiveButton1(buttonName);
  };

  const handleInputChange = (field, value) => {
    setUserQuery({ ...userQuery, [field]: value });
  };

  return (
    <div className="text-[#333] w-full bg-white p-12 rounded-xl">
      {/* Heading */}
      <div className="flex  items-center	">
        <h1 className=" px-4 py-1 text-[#333]   text-lg  font-semibold	">
          Financing Structure
        </h1>
        <h3 className="  text-[#037dfa]  text-xs font-medium   cursor-pointer  ">
          Learn More
        </h3>
      </div>

      <div className="flex flex-col  xl:p-4 ">
        <div className="flex space-x-12 mb-6">
          {/* Lien position */}

          <div className="w-full">
            <p className="text-sm font-semibold mb-[11px]">Lien Position</p>
            <div className="">
              <button
                className={`w-1/2 rounded-md font-medium py-1.5 ${
                  activeButton === "First"
                    ? "bg-[#e1effe] border border-[#61aefb] text-[#037dfa] "
                    : "bg-white border border-[#e0e0e0] text-black"
                } `}
                onClick={() => {
                  handleButtonClick("First");
                  setUserQuery({ ...userQuery, Lien_Position: "First" });
                }}
              >
                First
              </button>
              <button
                className={`w-1/2 rounded-md font-normal  py-1.5 ${
                  activeButton === "Second"
                    ? "bg-[#e1effe] border border-[#61aefb] text-[#037dfa] "
                    : "bg-white border border-[#e0e0e0] text-black"
                } `}
                onClick={() => {
                  handleButtonClick("Second");
                  setUserQuery({ ...userQuery, Lien_Position: "Second" });
                }}
              >
                Second
              </button>
            </div>
          </div>
          {/* Ammortization Type */}
          <div className="w-full">
            <p className="text-sm font-semibold mb-[11px]">Amortization Type</p>
            <div>
              <button
                className={`w-1/2 rounded-md font-medium py-1.5 ${
                  activeButton1 === "Fixed"
                    ? "bg-[#e1effe] border border-[#61aefb] text-[#037dfa] "
                    : "bg-white border border-[#e0e0e0] text-black"
                } `}
                onClick={() => {
                  handleButtonClick1("Fixed");
                  setUserQuery({ ...userQuery, amortization_type: "Fixed" });
                }}
              >
                Fixed
              </button>
              <button
                className={`w-1/2 rounded-md py-1.5 ${
                  activeButton1 === "ARM"
                    ? "bg-[#e1effe] border border-[#61aefb] text-[#037dfa] "
                    : "bg-white border border-[#e0e0e0] text-black"
                } `}
                onClick={() => {
                  handleButtonClick1("ARM");
                  setUserQuery({ ...userQuery, amortization_type: "ARM" });
                }}
              >
                ARM
              </button>
            </div>
          </div>
        </div>

        <div className="flex  space-x-12 mb-6">
          {/* Occupancy */}
          <div className="w-full flex flex-col">
            <Select
              options={data}
              label={"Occupancy"}
              value={userQuery.occupancy_status}
              handlechange={(e) =>
                handleInputChange("occupancy_status", e.target.value)
              }
            />
            {errors && (
              <p className=" text-[#ff6839] font-Poppins text-sm  mt-1  ">
                {errors.occupancy_status}
              </p>
            )}
          </div>
          {/* Loan Purpose */}
          <Select
            label={"Loan Purpose"}
            options={optionLoan}
            value={userQuery.Loan_purpose}
            handlechange={(e) =>
              handleInputChange("Loan_purpose", e.target.value)
            }
          />
        </div>

        <div className="flex space-x-12 mb-12 ">
          {/* Mortgage Type */}
          <Select
            label={"Mortgage Type"}
            options={optionMort}
            handlechange={(e) =>
              handleInputChange("Mortgage_Type", e.target.value)
            }
            value={userQuery.Mortgage_Type}
          />
          {/* Term */}

          {activeButton1 === "Fixed" && (
            <div className="flex flex-col w-full">
              <Input
                Label={"Term"}
                type = {"number"}
                value={userQuery.term}
                handlechange={(e)=> handleInputChange("term" , e.target.value)}
              />
              {errors && (
                <p className=" text-[#ff6839] font-Poppins text-sm px-5 mt-1   ">
                  {errors.term}
                </p>
              )}
            </div>
          )}
          {activeButton1 === "ARM" && (
            <Input
              Label={"First Adjustment Period"}
              type = {"number"}
              value={userQuery.First_Adjustment_Period}
              handlechange={(e) =>
                handleInputChange("First_Adjustment_Period", e.target.value)
              }
            />
          )}
        </div>
        {/* Property Value */}
        <div className="bg-[#F6F8FB] p-12 rounded-lg ">
          <div className="">
            <p className="font-semibold text-[#333] mb-8">Property Value</p>
            <Input
              value={userQuery.Property_Value}
              handlechange={(e) =>
                handleInputChange("Property_Value", e.target.value)
              }
              Placeholder={"$1,000,000,000"}
              type = {"number"}
            />
            {errors && (
              <p className=" text-[#ff6839] font-Poppins text-sm px-3 mt-1   ">
                {errors.Property_Value}
              </p>
            )}
          </div>

          <hr className="bg-gray-300 h-px my-8" />

          {/* LTV */}

          <div className="flex space-x-12 w-full mb-6">
            <Input
              Label={"Base Loan Amount"}
              value={userQuery.Base_loan_amount}
              type = {"number"}
            />
            <div className="w-2/5">
              <Input
                Label={"LTV"}
                value={userQuery.ltv}
                handlechange={(e) => handleInputChange("ltv", e.target.value)}

                Placeholder={"70"}
                type = {"number"}
              />
              {errors && (
                <p className=" text-[#ff6839] font-Poppins text-sm px-3 mt-1   ">
                  {errors.ltv}
                </p>
              )}
            </div>
          </div>

          {/* CLTV */}

          <div className="flex space-x-12 w-full mb-6">
            <Input
              Label={"Other Financing"}
              value={userQuery.other_financing}
              type = {"number"}
            />
            <div className="w-2/5">
              <Input
                Label={"CLTV"}
                value={userQuery.cltv}
                handlechange={(e) => handleInputChange("cltv", e.target.value)}
                type = {"number"}
              />
              {errors && (
                <p className=" text-[#ff6839] font-Poppins text-sm px-3 mt-1   ">
                  {errors.cltv}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Finance;
